import { type IRenderer, type IRendererRegistry } from './types';

/**
 * 渲染器注册表实现
 * 负责管理所有渲染器的注册、查找、注销等操作
 */
export class RendererRegistry implements IRendererRegistry {
  /** 渲染器存储 */
  private renderers = new Map<string, IRenderer>();

  /**
   * 注册渲染器
   * @param name - 渲染器名称
   * @param renderer - 渲染器实例
   */
  register(name: string, renderer: IRenderer): void {
    // 验证渲染器实现
    if (!renderer.name || !renderer.version) {
      throw new Error('Invalid renderer: name and version are required');
    }

    if (typeof renderer.create !== 'function') {
      throw new Error('Invalid renderer: create method is required');
    }

    if (this.renderers.has(name)) {
      console.warn(`渲染器 "${name}" 已存在，将被覆盖`);
    }
    this.renderers.set(name, renderer);
  }

  /**
   * 获取渲染器
   * @param name - 渲染器名称
   * @returns 渲染器实例或undefined
   */
  get(name: string): IRenderer | undefined {
    return this.renderers.get(name);
  }

  /**
   * 检查渲染器是否存在
   * @param name - 渲染器名称
   * @returns 是否存在
   */
  has(name: string): boolean {
    return this.renderers.has(name);
  }

  /**
   * 获取所有渲染器
   * @returns 渲染器映射表的副本
   */
  getAll(): Map<string, IRenderer> {
    return new Map(this.renderers);
  }

  /**
   * 注销渲染器
   * @param name - 渲染器名称
   * @returns 是否成功注销
   */
  unregister(name: string): boolean {
    return this.renderers.delete(name);
  }

  /**
   * 获取已注册渲染器数量
   * @returns 渲染器数量
   */
  get size(): number {
    return this.renderers.size;
  }

  /**
   * 清空所有渲染器
   */
  clear(): void {
    this.renderers.clear();
  }
}
